import { MessageResponseDto } from "@api/api";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { levelFormDefault } from "@factory/form/form.default";
import { LevelFormRule, LevelFormSchema } from "@factory/form/form.rule";
import { useQyCreateLevel } from "@factory/query/level.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewLevel() {
  // LOCAL DECLARATION
  const { getUserRole } = useUserIdentityContext();
  const { tenant } = getUserRole();
  const navigate = useNavigate();
  const { mapCreateLevel } = useFormApiMapper();
  const { showError, showSuccess } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Level is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addLevel, isLoading: isCreating } =
    useQyCreateLevel(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<LevelFormSchema>({
    defaultValues: levelFormDefault,
    resolver: zodResolver(LevelFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: LevelFormSchema) => {
    const updatedForm = {
      ...form,
      tenant,
    };
    const formData = mapCreateLevel(updatedForm);
    addLevel(formData);
  };
  const handleValidateError = (err: FieldErrors<LevelFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
